module.exports = __webpack_public_path__ + "img/langchao.fbea85ea.png";